import { useEffect, useRef } from "react";
import api from "@/lib/api";

const VERBS = {
  added: "added", ticked: "ticked off", unticked: "put back", removed: "removed",
  swapped: "swapped", cleared: "cleared", joined: "joined the list",
};

export const activityText = (ev) =>
  `${ev.actor_name} ${VERBS[ev.action] || ev.action}${ev.item_name ? ` ${ev.item_name}` : ""}`;

// Polls shared-list activity every 3s while the tab is visible.
export default function useShoppingSync({ enabled, listOwner, onEvents }) {
  const sinceRef = useRef(new Date().toISOString());
  const cbRef = useRef(onEvents);
  cbRef.current = onEvents;

  useEffect(() => {
    if (!enabled) return undefined;
    sinceRef.current = new Date().toISOString();
    let busy = false;
    const tick = async () => {
      if (busy || document.hidden) return;
      busy = true;
      try {
        const params = { since: sinceRef.current, ...(listOwner ? { list_id: listOwner } : {}) };
        const { data } = await api.get("/shopping-list/activity", { params });
        sinceRef.current = data.now;
        if (data.events?.length) cbRef.current(data.events);
      } catch { /* transient — next tick retries */ }
      busy = false;
    };
    const id = setInterval(tick, 3000);
    return () => clearInterval(id);
  }, [enabled, listOwner]);
}
